
/**
 * 
 * @param data new Date(24/04/2024)
 * @returns 24/04/2024
 */
export const dateToString = (data: Date) => {
    if(!data) return;
    // Obter o dia, mês e ano da data atual
    const dia = data.getDate();
    const mes = data.getMonth() + 1; // Os meses começam do zero, então é necessário adicionar 1
    const ano = data.getFullYear();

    // Formatar os valores para o formato DD/MM/AAAA
    return `${dia.toString().padStart(2, '0')}/${mes.toString().padStart(2, '0')}/${ano}`;
}

/**
 * 
 * @param data new Date(24/04/2024)
 * @returns 2024-04-24
 */
export const dateToEnglishDateString = (data: Date) => {
    if(!data) return;
    // Obter o dia, mês e ano da data atual
    const dia = data.getDate();
    const mes = data.getMonth() + 1; // Os meses começam do zero, então é necessário adicionar 1
    const ano = data.getFullYear();

    // Formatar os valores para o formato DD/MM/AAAA
    return `${ano}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;
}

/**
 * 
 * @param data new Date(24/04/2024)
 * @returns 2024-04-24T16:52:10
 */
export const dateToEnglishDateStringAndHour = (data: Date) => {
    if(!data) return;
    const pad = (n: number) => n.toString().padStart(2, '0');

    // Obter o dia, mês e ano da data atual
    const ano = data.getFullYear();
    const mes = pad(data.getMonth() + 1); // Os meses começam do zero, então é necessário adicionar 1
    const dia = pad(data.getDate());
    const hora = pad(data.getHours());
    const minutos = pad(data.getMinutes());
    const segundos = pad(data.getSeconds());
    
    
    return `${ano}-${mes}-${dia}T${hora}:${minutos}:${segundos}`;
}

/**
 * 
 * @param data new Date(24/04/2024)
 * @returns 24/04/2024 - 12:15
 */
export const dateToStringDateAndHour = (date: Date) => {
    const dateString = dateToString(date);

    const pad = (n: number) => n.toString().padStart(2, '0');

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    // Formatar os valores para o formato DD/MM/AAAA - HH:mm
    return `${dateString} - ${hours}:${minutes}`;
}

/**
 * 
 * @param data new Date(24/04/2024)
 * @returns 24/04/2024 - 12:15:00
 */
export const dateToStringDateAndHourSeconds = (date: Date) => {
    const dateString = dateToString(date);

    const pad = (n: number) => n.toString().padStart(2, '0');

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    // Formatar os valores para o formato DD/MM/AAAA - HH:mm:ss
    return `${dateString} - ${hours}:${minutes}:${seconds}`;
}

/**
 * 
 * @param data 2024-04-24
 * @returns new Date(24/04/2024)
 */
export const englishDateStringToDate = (data: string) => {
    const date = new Date();

    const [ano, mes, dia] = data.split('-');

    date.setFullYear(Number(ano));
    date.setMonth(Number(mes));
    date.setDate(Number(dia));
    return date;
}

/**
 * 
 * @param data 2024-04-24
 * @returns 24/04/2024
 */
export const englishDateStringToPortugueseDateString = (data: string) => {
    const dataObj = englishDateStringToDate(data);
    return dateToString(dataObj);
}

/**
 * 
 * @param data 2024-04-24T16:52:10
 * @returns 24/04/2024
 */
export const unformatedStringDateToPortugueseDateString = (data: string) => {
    if(!data) return '';
    return dateToString(new Date(data));
}

/**
 * 
 * @param data 2024-04-24T16:52:10
 * @returns 24/04/2024 - 12:15
 */
export const unformatedStringDateHourToPortugueseDateHourString = (data: string) => {
    if(!data) return '';
    return dateToStringDateAndHour(new Date(data));
}